<template>
  <button id="RECORD" name="RECORD" class="btn" data-vcode="RECORD">
    <img class="soft-img" src="/images/icn-record.svg" alt="" role="img" aria-hidden="true" />
        <label> {{ $t('recordButton') }}</label>
  </button>
</template>
<script>
export default {};
</script>
